import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

import Dropzone from '../../ImageDropdown/Dropzone';
import { useCallback } from 'react';

export default function LogoUploadError({ setFailed, setImage, setLoading }) {

    // get dropped images
    const onDrop = useCallback((acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file && file.type.startsWith('image/')) {
        setImage(file);
      } else {
        setFailed(true);
      }
    }, []);

  const handleFile = (e) => {
    let img = e.target.files[0];
    console.log(img)
    if (img && img.type.startsWith('image/')) {
      setLoading(true)
      setImage(img);
      setLoading(false)
      setFailed(false)
    } else {
      setFailed(true)
    }
  }

  return (
    <>
      <div className="step2b-container">
        <div className="step2b">
        <Dropzone 
          onDrop={onDrop} 
          accept={{
            'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.webp', '.svg']
          }}
        />
          <div className="step2b-heading">
            <h2>Oops !</h2>
            <span>Image format not supported</span>
          </div>
          <div className="step2b-drop-image">
            <ErrorOutlineRoundedIcon />
          </div>
          <div className="step2b-drop-text">
            <h3>Please select an image file</h3>
            <div>Drag an image here or <span className='browse'>Browse <input type="file" className='get-img' accept="image/*" onChange={handleFile} /></span> for an image to upload</div>
          </div>
        </div>
      </div>
    </>

  )
}
